<template>
  <MobileServiceOverview
    class="academic-services-view"
    v-bind="academicServicesOverview"
    :hero-image="academicServicesHeroImage"
  />
</template>

<script>
import MobileServiceOverview from '@/components/content/MobileServiceOverview.vue'
import academicServicesHeroImage from '@/assets/pages/academic-services/images/academic-services-mobile-hero.webp'

export default {
  name: 'AcademicServicesView',
  components: {
    MobileServiceOverview
  },
  data() {
    return {
      academicServicesHeroImage,
      academicServicesOverview: {
        eyebrow: '学术服务',
        title: '三擎驱动，构建全链路教育生态',
        summary: '以人工智能产学研为核心，贯通青少年成长服务、大学协同创新与教育产品建设。',
        metrics: [
          { value: '10万+', label: '辐射生源' },
          { value: '50人', label: '综合评价团队' },
          { value: '100+', label: '合作机构' }
        ],
        highlights: [
          {
            kicker: '全程陪伴',
            title: '全周期学涯服务',
            description: '覆盖生涯测评、学习激励、升学通道选择与志愿指导，为青少年提供全流程成长规划。'
          },
          {
            kicker: '协同联动',
            title: '一体化业务矩阵',
            description: '联动智谷科技、智谷教育与智谷优学，推动技术研发、人才培养和人工智能科普协同发展。'
          },
          {
            kicker: '高校共建',
            title: '专家生态',
            description: '汇聚东北大学、辽宁大学、辽宁科技大学等高校专家，持续强化学涯规划与产学研服务能力。'
          }
        ]
      }
    }
  }
}
</script>
